import React, { useCallback, useEffect, useState, } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { getConfig, getCustomizable } from '../configure';
import { TabsPosition, TabsType } from './enum';
import TabPane from './TabPane';
import TabGroup from './TabGroup';
import TabsWithContext from './TabsWithContext';
const Tabs = function Tabs(props) {
    const { customizedCode, customizable = customizedCode ? getCustomizable('Tabs') : undefined, } = props;
    const $customizable = customizedCode ? customizable : false;
    const [loaded, setLoaded] = useState(!$customizable);
    const [customized, setCustomized] = useState();
    const loadCustomized = useCallback(async () => {
        if (customizedCode) {
            setLoaded(false);
            const customizedLoad = getConfig('customizedLoad');
            try {
                const remoteCustomized = await customizedLoad(customizedCode, 'Tabs');
                setCustomized({ panes: {}, ...remoteCustomized });
            }
            finally {
                setLoaded(true);
            }
        }
    }, [customizedCode]);
    useEffect(() => {
        if ($customizable) {
            loadCustomized();
        }
    }, [$customizable, loadCustomized]);
    return loaded ? (React.createElement(TabsWithContext, Object.assign({}, props, { customized: customized, setCustomized: setCustomized, customizable: $customizable }))) : null;
};
Tabs.displayName = 'Tabs';
Tabs.propTypes = {
    destroyInactiveTabPane: PropTypes.bool,
    onChange: PropTypes.func,
    children: PropTypes.any,
    prefixCls: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    activeKey: PropTypes.string,
    defaultActiveKey: PropTypes.string,
    keyboard: PropTypes.bool,
    hideAdd: PropTypes.bool,
    tabPosition: PropTypes.oneOf([TabsPosition.top, TabsPosition.right, TabsPosition.bottom, TabsPosition.left]),
    type: PropTypes.oneOf([TabsType.card, TabsType.line, TabsType['editable-card']]),
};
Tabs.defaultProps = {
    hideAdd: false,
    destroyInactiveTabPane: false,
    onChange: noop,
    keyboard: true,
    tabPosition: TabsPosition.top,
    type: TabsType.line,
};
Tabs.TabPane = TabPane;
Tabs.TabGroup = TabGroup;
export default Tabs;
